"use client";
import { JSX } from "react";

export function ReactScan(): JSX.Element {
  // Disabled - was causing infinite console logs
  return <></>;
}
